import React from 'react';

function CareersHero() {
  return (
    <section className="team-hero" style={{ backgroundImage: "url('/assets/images/careers-bg.jpg')" }}>
      {/* Dark overlay matching the team hero color scheme */}
      <div className="team-hero-overlay"></div>

      {/* Hero Content */}
      <div className="container team-hero-container">
        <div className="team-hero-content">
          <h1 className="team-hero-title">
            Build Your Career With Experts Communication
          </h1>
          <p className="team-hero-description">
            Join an innovative, fast-growing team of passionate professionals in BPO, IT services, web development, and digital marketing. We empower exceptional talent to learn, innovate, and thrive in an inclusive and dynamic environment.
          </p>
        </div>
      </div>
    </section>
  );
}

export default CareersHero;
